import { render, staticRenderFns } from "./itinerary.vue?vue&type=template&id=5f2d3728&scoped=true"
import script from "./itinerary.vue?vue&type=script&lang=js"
export * from "./itinerary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d3728",
  null
  
)

export default component.exports